import { LabeledText } from '../../../components/LabeledText';
import clsx from 'clsx';

interface Props {
  items: ReviewItem[];
  itemOrientation?: 'vertical' | 'horizontal';
}

export const ReviewItems = ({
  items,
  itemOrientation = 'horizontal',
}: Props) => (
  <div className="flex flex-row items-start gap-4">
    {items.map((item, index) => (
      <LabeledText
        className={clsx({
          '!text-error':
            item.required && (item.value === undefined || item.value === ''),
        })}
        key={`item-${index + 1}`}
        align={item.align}
        label={item.label}
        text={
          item.value !== undefined && item.value !== ''
            ? item.value.toString()
            : item.defaultValue
        }
        orientation={itemOrientation}
        labelSize={12}
        maxWidth={item.maxWidth}
        noWrap={item.noWrap}
        textSize={14}
      />
    ))}
  </div>
);
